import React, { useEffect } from "react";
import NetwalaModal from "../Items/Modal/Index";
import { Col, Row, Form, Input } from "antd";
import "./styles/RequestIPTVModal.css";
import NetwalaButton from "../Items/Button/Index";
import { ButtonProps } from "../../helpers/constants";
import useAxiosPost from "../../hooks/useAxiosPost";
import useMultiNotification from "../../hooks/useNotification";
const CreateSubAreaModal: React.FC<CreateSubAreaModalProps> = ({
  show,
  handleClose,
  parent_intPkAreaID,
}) => {
  const { openNotification, contextHolder } = useMultiNotification();

  const [
    postApiData,
    apiResponse,
    apiError,
    apiLoading,
    apiMessage,
    apiErrorCount,
  ] = useAxiosPost<createNewSubAreaApiProp>("areas/CreateNewSubArea", true);

  const onFinish = (values: any) => {
    const { areaName } = values;
    postApiData({ areaName: areaName.trim(), parent_intPkAreaID });
  };
  useEffect(() => {
    if (apiResponse !== null) {
      const { message } = apiResponse;
      if (message) {
        openNotification("success", "Success", message);
        setTimeout(() => {
          handleClose(true);
        }, 2500);
      }
    }
  }, [apiResponse]);
  useEffect(() => {
    if (apiError !== null && apiErrorCount !== 0) {
      openNotification("error", "Error", apiError);
    }
  }, [apiError, apiErrorCount]);
  const onFinishFailed = (errorInfo: any) => {
    console.log("Failed:", errorInfo);
  };

  return (
    <>
      <NetwalaModal
        title="Create Sub Area"
        headerStyle={{
          backgroundColor: "#292D8E",
          color: "#FFFFFF",
          fontSize: "16px",
          fontWeight: "400",
          height: "50px",
        }}
        open={show}
        onCancel={() => handleClose(false)}
      >
        {contextHolder}

        <Row>
          <Col span={24} className="iptv-modal-package-details">
            <Form
              requiredMark={false}
              style={{ width: "100%", marginTop: "50px" }}
              layout="vertical"
              onFinish={onFinish}
              onFinishFailed={onFinishFailed}
              name="createAreaForm"
            >
              <Form.Item
                label={
                  <span className="create-user-form-label">Sub Area Name</span>
                }
                name="areaName"
                rules={[
                  {
                    required: true,
                    message: "Please Enter Area Name",
                  },
                  {
                    min: 5,
                    message: "Area Name Should be more than 5 characters",
                  },
                  {
                    pattern: /^[a-zA-Z0-9\s\-_.]+$/,
                    message: "Sub Area Name can only contain letters, numbers, spaces, hyphens (-), underscores (_), and periods (.)",
                  },
                  {
                    whitespace: true,
                    message: "Sub Area Name cannot be empty or contain only spaces",
                  },
                ]}
              >
                <Input
                  className="user-input-general-height"
                  placeholder="Main Market"
                />
              </Form.Item>

              <Form.Item>
                <NetwalaButton
                  backgroundColor={ButtonProps.background.YELLOW}
                  height={ButtonProps.height.STANDARD}
                  width={`100%`}
                  textColor={ButtonProps.color.STANDARD}
                  onClick={() => {}}
                  htmlType="submit"
                  text="Create Sub Area"
                  borderColor="#FFA726"
                  disabled={apiLoading}
                />
              </Form.Item>
            </Form>
          </Col>
        </Row>
      </NetwalaModal>
    </>
  );
};

export default CreateSubAreaModal;
